export default {
  'settings.title': 'Cấu hình Contract',
  'settings.alert.title': 'Quản trị Smart Contract (Zero-Secrets)',
  'settings.alert.description': 'Hệ thống đã được chuyển sang chế độ bảo mật cao: Không lưu trữ Private Key. Vui lòng kết nối ví cá nhân (MetaMask) của Admin để ký giao dịch.',
  'settings.auth.title': 'Xác thực Quản trị viên',
  'settings.auth.connected': 'Đã kết nối ví: {address}',
  'settings.auth.changeWallet': 'Đổi ví khác',
  'settings.auth.logout': 'Đăng xuất / Ngắt kết nối',
  'settings.auth.connectBtn': 'Kết nối ví Admin (MetaMask)',
  'settings.cowe.title': 'Cấu hình Token COWe',
  'settings.cowe.contract': 'Contract: {address}',
  'settings.cowe.minBalance.title': 'Tham số: Min Balance To Unlock',
  'settings.cowe.minBalance.current': 'Hiện tại: {amount} COWe',
  'settings.cowe.minBalance.label': 'Cập nhật (COWe)',
  'settings.cowe.minBalance.save': 'Lưu Min Balance',
  'settings.cowe.setUserLevel.title': 'Set User Level (Thủ công)',
  'settings.cowe.setUserLevel.wallet': 'Địa chỉ ví',
  'settings.cowe.setUserLevel.level': 'Level (0-2)',
  'settings.cowe.setUserLevel.btn': 'Thực hiện Set Level',
  'settings.mining.title': 'Cấu hình Mining Contract',
  'settings.mining.contract': 'Contract: {address}',
  'settings.mining.rate.title': 'Tốc độ Đào (COWe / giây)',
  'settings.mining.rate.l1': 'Level 1',
  'settings.mining.rate.l2': 'Level 2',
  'settings.mining.rate.save': 'Lưu Tốc độ đào',
  'settings.mining.session.title': 'Thời lượng Phiên đào',
  'settings.mining.session.label': 'Đơn vị: Giờ',
  'settings.mining.session.save': 'Lưu Thời lượng',
  'settings.mining.referral.title': 'Cơ chế Giới thiệu (Referral)',
  'settings.mining.referral.percent': '% Hoa hồng lượng đào',
  'settings.mining.referral.actBonus': 'Thưởng ngay khi Kích hoạt (COWe)',
  'settings.mining.referral.refBonus': 'Thưởng ngay cho Người giới thiệu (COWe)',
  'settings.mining.referral.save': 'Lưu Chỉ số Giới thiệu',
  'settings.msg.loading': 'Đang tải...',
  'settings.msg.initError': 'Lỗi khi khởi tạo contract:',
  'settings.msg.rpcError': 'Không thể kết nối RPC để đọc dữ liệu Contract',
  'settings.msg.metamaskError': 'Vui lòng cài đặt MetaMask hoặc ví Web3 tương đương',
  'settings.msg.connectSuccess': 'Đã kết nối ví thành công',
  'settings.msg.connectFail': 'Không thể kết nối ví',
  'settings.msg.readError': 'Lỗi đọc tham số contract:',
  'settings.msg.chainError': 'Lỗi khi đọc on-chain data.',
  'settings.msg.connectFirst': 'Vui lòng kết nối ví trước khi thực hiện',
  'settings.msg.txConfirm': 'Đang gửi giao dịch, vui lòng xác nhận trên ví...',
  'settings.msg.updateSuccess': 'Cập nhật thành công!',
  'settings.msg.setLevelSuccess': 'Set Level thành công!',
  'settings.msg.rateSuccess': 'Cập nhật Tốc độ đào thành công!',
  'settings.msg.sessionSuccess': 'Cập nhật Phiên đào thành công!',
  'settings.msg.referralSuccess': 'Cập nhật Cơ chế giới thiệu thành công!',
  'settings.msg.txPending': 'Giao dịch đang chờ xác nhận...',
  'settings.sync.title': 'Đồng bộ Referral (Sync Tool)',
  'settings.sync.description': 'Quét và đồng bộ số lượng referral cũ từ hệ thống cũ lên Blockchain cho các ví đã migrate.',
  'settings.sync.scanBtn': 'Quét ví đã Migrate',
  'settings.sync.col.wallet': 'Ví hiện tại',
  'settings.sync.col.oldWallet': 'Ví cũ',
  'settings.sync.col.count': 'Số lượng Ref',
  'settings.sync.col.action': 'Hành động',
  'settings.sync.action.syncBtn': 'Sync lên Chain',
  'settings.sync.msg.noData': 'Không tìm thấy ví nào cần đồng bộ.',
  'settings.sync.msg.success': 'Đã đồng bộ referral cho {address} thành công!',
  'settings.sync.msg.fail': 'Đồng bộ thất bại cho {address}: {error}',
  'settings.sync.col.status': 'Trạng thái',
  'settings.sync.col.referrerOnChain': 'Người mời (On-chain)',
  'settings.sync.status.success': 'Thành công',
  'settings.sync.status.self': 'Tự mời',
  'settings.sync.status.notSynced': 'Chưa đồng bộ',
  'settings.sync.status.root': 'Người dùng gốc',
  'settings.sync.status.none': 'Chưa có',
  'settings.sync.modal.title': 'Chi tiết Referral - {address}',
  'settings.sync.modal.col.wallet': 'Ví Referral',
  'settings.sync.modal.col.status': 'Trạng thái On-chain',
  'settings.sync.modal.status.synced': 'Đã đồng bộ thành công',
  'settings.sync.modal.close': 'Đóng',
};
